import React from 'react';
import type { StartAnime } from '@types';
import { Collapse } from '@components/Collapse';
import Title from '@components/Title';
import useTourEditing from '@hooks/useTourEditing';
import FeatureToggle from '@components/FeatureToggle';
import PanelBase from '../PanelBase';
import type { PanelBaseProps } from '../types';

type AnimeSceneType = keyof StartAnime;

const animeMap: {
  [P in AnimeSceneType]: { id: Required<StartAnime>[P]; name: string }[];
} = {
  pano: [
    { id: 1, name: '小行星开场' },
    { id: 2, name: '水平巡游开场' },
    { id: 3, name: '水晶球开场' },
    { id: 4, name: '小行星巡游开场' },
    { id: 5, name: '小行星缩放开场' },
  ],
  video: [
    { id: 1, name: '小行星开场' },
    { id: 2, name: '水平巡游开场' },
    { id: 3, name: '水晶球开场' },
  ],
  matrix: [{ id: 1, name: '缩放开场' }],
};

function StartAnimeBase({
  defaultValue,
  onConfirm,
}: PanelBaseProps<StartAnime>) {
  const { state, setState, isChanged } = useTourEditing(defaultValue, {
    pano: 1,
    video: 1,
    matrix: 1,
  });

  return (
    <PanelBase
      title={<Title>开场动画</Title>}
      isChanged={isChanged}
      onHelpClick={() => {}}
      onConfirm={() => onConfirm(state)}
    >
      <Collapse title="全景图片开场动画">
        {animeMap.pano.map((x) => (
          <FeatureToggle
            key={x.id}
            title={x.name}
            isOn={state.pano === x.id}
            onToggle={(bool) =>
              setState((draft) => {
                draft.pano = bool ? x.id : 0;
              })
            }
          />
        ))}
      </Collapse>
      <Collapse title="全景视频开场动画">
        {animeMap.video.map((x) => (
          <FeatureToggle
            key={x.id}
            title={x.name}
            isOn={state.video === x.id}
            onToggle={(bool) =>
              setState((draft) => {
                draft.video = bool ? x.id : 0;
              })
            }
          />
        ))}
      </Collapse>
      <Collapse title="高清矩阵开场动画">
        {animeMap.matrix.map((x) => (
          <FeatureToggle
            key={x.id}
            title={x.name}
            isOn={state.matrix === x.id}
            onToggle={(bool) =>
              setState((draft) => {
                draft.matrix = bool ? x.id : 0;
              })
            }
          />
        ))}
      </Collapse>
    </PanelBase>
  );
}

export default StartAnimeBase;
